import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomItemCategoryBlocksComponent} from './custom-item-category-blocks-component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {RouterModule} from '@angular/router';



@NgModule({
  declarations: [CustomItemCategoryBlocksComponent],
  exports: [CustomItemCategoryBlocksComponent],
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ItemCategoryBlocksComponentComponent: {
          component: CustomItemCategoryBlocksComponent,
        },
      },
    } as CmsConfig),
    RouterModule,
  ]
})
export class CustomItemCategoryBlocksComponentModule { }
